import { ProcessGeneral } from 'api/endpoints/processes';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync, isApiError } from 'container/models';
import { IGeneralPayablesExtractionPlanRepo } from 'features/generalPayables/services/extractionPlans/IGeneralPayablesExtractionPlanRepo';
import {
  CreateExtractionPlanRequest,
  ExtractionPlan,
  SearchExtractionPlanRequest,
  UpdateExtractionPlanType,
} from 'features/shared/licensedModules/types';

export class GeneralPayablesExtractionPlansRepo
  extends BaseRepo
  implements IGeneralPayablesExtractionPlanRepo
{
  search = async (
    draft: ProcessGeneral,
    request: SearchExtractionPlanRequest
  ): ApiResponseAsync<ExtractionPlan[]> => {
    const link = draft._links?.['searchGeneralPayablesExtractionPlans'];
    if (!link)
      return buildBadRequestApiError(
        new Error(
          'link "search General Payables extraction plans" is not available'
        )
      );

    const result = await this.helpers.executeSearch<ExtractionPlan[]>(
      link,
      request,
      { convertRequestToSnakeCase: true }
    );

    if (isApiError(result)) return result;

    return result ?? [];
  };

  create = async (
    draft: ProcessGeneral,
    request: CreateExtractionPlanRequest
  ): ApiResponseAsync<ExtractionPlan> => {
    const link = draft._links?.['createGeneralPayablesExtractionPlan'];
    if (!link)
      return buildBadRequestApiError(
        new Error(
          'link "create General Payables extraction plan" is not available'
        )
      );

    return this.helpers.handlePost(link.href, request);
  };

  update = async (
    plan: ExtractionPlan,
    request: UpdateExtractionPlanType
  ): ApiResponseAsync<ExtractionPlan> => {
    const link = plan._links?.['update'];
    if (!link)
      return buildBadRequestApiError(
        new Error('link "update" is not available')
      );

    return this.helpers.executePatch(link, request);
  };

  delete = async (plan: ExtractionPlan): ApiResponseAsync<void> => {
    const link = plan._links?.['delete'];
    if (!link)
      return Promise.resolve(
        buildBadRequestApiError(new Error('link "delete" is not available'))
      );

    return this.helpers.handleDelete(link.href);
  };
}
